<template>
  <div>
    <div class="container mt-5 text-left">
      <div class="row description-area">
        <div :class="[RegionClass + ' col-lg-6 region-left region-icon']">
          <nav aria-label="breadcrumbs">
            <b-breadcrumb>
              <b-breadcrumb-item
                v-for="breadcrumb in Breadcrumbs"
                :key="breadcrumb.id"
                :text="breadcrumb.text"
                :to="breadcrumb.href"
                :active="breadcrumb.active"
              />
            </b-breadcrumb>
          </nav>
          <b-img-lazy
            :alt="ImageAlt"
            :src="Image ? Image : '/images/misc/city-no-image.png'"
            itemprop="image"
            class="img-fluid mobile-img"
          />
          <h1 itemprop="name">{{ Title }}</h1>
          <span v-if="isPassed">
            <span
              class="event--date is-passed"
              itemprop="startDate"
              :content="startDate"
              v-if="startDate || endDate"
              >{{ getStartDate }}</span
            >
            <span
              class="event--date is-passed"
              itemprop="endDate"
              :content="endDate"
              v-if="startDate !== endDate"
            >
              - {{ getEndDate }}</span
            >
            <span class="is-passed-text">Event has already occurred</span>
          </span>
          <span v-else>
            <span
              class="event--date"
              itemprop="startDate"
              :content="startDate"
              v-if="startDate || endDate"
              >{{ getStartDate }}</span
            >
            <span
              class="event--date"
              itemprop="endDate"
              :content="endDate"
              v-if="startDate !== endDate"
            >
              - {{ getEndDate }}</span
            >
            <span class="event--time" v-if="time">{{ time }}</span>
          </span>
          <span itemprop="location" itemscope itemtype="http://schema.org/Place">
            <span itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
              <router-link
                class="city--link"
                itemprop="addressLocality"
                v-if="City && CitySlug"
                :to="`/places-to-go/cities-and-towns/${CitySlug}`"
                >{{ City }}</router-link
              >
              <p class="city--link" itemprop="addressLocality" v-else>{{ City }}</p>
            </span>
          </span>
          <div class="discription-wrapper">
            <p
              v-html="Description"
              itemprop="description"
              data-swiftype-name="body"
              data-swiftype-type="text"
            ></p>
            <div v-if="ARW && ARW.length > 0">
              <h2>Alabama Restaurant Week Menu</h2>
              <ul class="list-unstyled">
                <li v-for="item in ARW" :key="item" class="menu-item">
                  <span class="time-of-day-menu-item">{{ item.time_of_day }}:</span>
                  {{ item.description }}, ${{ item.cost }}.00
                </li>
              </ul>
            </div>
          </div>
          <Badges v-if="Badges" :badges="Badges" />
          <div class="mobile-cta-wrapper">
            <span class="cta-mobile">
              <a
                v-if="Website"
                :href="Website"
                class="button no-carrot"
                rel="noopener noreferrer"
                target="_blank"
                >Visit Website
                <IconBase variant="external-link" color="#FFF" classes="external-link-icon" size="16" />
              </a>
              <a class="m-phone" :href="'tel:' + Phone" v-if="Phone"
                ><img
                  src="/images/partners/phone-white.svg"
                  alt=""
                  class="phone-mobile"
                  role="presentation"
                />
                Call Us</a
              >
            </span>
            <a
              v-if="TicketLink"
              :href="TicketLink"
              class="ticket-button button"
              rel="noopener noreferrer"
              target="_blank"
              >Get Tickets <IconBase variant="external-link" color ="#FFF" classes="external-link-icon" size="16" />
            </a>
          </div>
        </div>
        <div class="col-lg-6 border-left region-right">
          <CountyMap
            v-if="Counties"
            :region="RegionClass"
            :counties="Counties.map((c) => c.toLowerCase())"
            :ScaleX="1"
            :ScaleY="1"
            :Rotate="-7"
          />
          <UserFavorite
            v-if="idToFavorite"
            :objectid="idToFavorite"
            :favorite="isFavorite(idToFavorite)"
          />
          <b-img-lazy
            v-if="Image == 'https://alabama-travel.s3.amazonaws.com/partners-uploads/photo/image/undefined/undefined'"
            :alt="ImageAlt"
            :src="AttractionImages && AttractionImages[0] && AttractionImages[0].imageUrl ? AttractionImages[0].imageUrl : '/images/misc/city-no-image.png'"
            itemprop="image"
            class="img-fluid desktop-img"
          />
          <b-img-lazy
            v-else
            :alt="ImageAlt"
            :src="Image ? Image : '/images/misc/city-no-image.png'"
            itemprop="image"
            class="img-fluid desktop-img"
          />
          <span v-if="ImageCredit">{{ ImageCredit }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserFavorite from '@/components/Common/UserFavorite.vue';
import Badges from '@/components/PlacesToGo/Attractions/Badges.vue';
import CountyMap from '@/components/PlacesToGo/Common/CountyMap.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { convertToDate, getOrdinalFormattedDate } from '../../../store/helpers/helpers';
import IconBase from '../../Common/icons/index.vue';

@Component({
  components: {
    CountyMap,
    Badges,
    UserFavorite,
    IconBase,
  },
  methods: {
    isFavorite(objectid) {
      return this.$store.getters['favorites/isFavorite'](objectid);
    },
  },
  mounted() {},
  computed: {
    isPassed() {
      if (this.endDate && new Date() > convertToDate(this.endDate)) {
        return true;
      }
      return false;
    },
  },
})
class DetailHeader extends Vue {
  @Prop({ type: String })
  Title;

  @Prop({ type: String })
  Description;

  @Prop({ type: String })
  Image;

  @Prop({ type: String })
  ImageAlt;

  @Prop({ type: String })
  ImageCredit;

  @Prop({ type: Array })
  AttractionImages;

  @Prop({ type: String })
  Region;

  @Prop({ type: Array })
  Counties;

  @Prop({ type: Array })
  Badges;

  @Prop({ type: String })
  Website;

  @Prop({ type: String })
  Phone;

  @Prop({ type: String })
  TicketLink;

  @Prop({ type: Array })
  Breadcrumbs;

  @Prop({ type: String })
  City;

  @Prop({ type: String })
  startDate;

  @Prop({ type: String })
  endDate;

  @Prop({ type: String })
  time;

  @Prop({ type: String })
  idToFavorite;

  @Prop({ type: String })
  SummaryText;

  @Prop({ type: Array })
  ARW;

  @Prop({ type: String })
  CitySlug;

  get getEndDate() {
    return getOrdinalFormattedDate(convertToDate(this.endDate));
  }

  get getStartDate() {
    return getOrdinalFormattedDate(convertToDate(this.startDate));
  }

  get RegionClass() {
    switch (this.Region) {
      case 'North Alabama':
      case 'north-alabama':
        return 'north-alabama';
      case 'Central Alabama':
      case 'central-alabama':
        return 'central-alabama';
      case 'South Alabama':
      case 'south-alabama':
        return 'south-alabama';
      case 'Beaches & Gulf Coast':
      case 'beaches-gulf-coast':
        return 'beaches-gulf-coast';
      case 'makers':
        return 'makers';
      case 'trail-detail':
        return 'trail-detail';
      default:
        return 'north-alabama';
    }
  }
}

export default DetailHeader;
</script>

<style lang="scss" scoped>
a.m-phone,
.mobile-img {
  display: none;
}

h1 {
  font-family: IdealSans-Medium;
  font-size: 45px;
  line-height: 4rem;

  @media only screen and (min-width: 769px) {
    font-size: 60px;
  }
}

.border-left {
  border-left: 1px solid #415421 !important;
  padding-bottom: 35px;
}

.city--link {
  color: #d86f48;
  display: block;
  margin: 6px 0;
}

.event--time {
  display: block;
}

.event--date,
.event--time {
  font-family: 'klinicslabmedium';
  font-size: 1.55rem;
}

.external-link-icon {
  font-size: 15px;
  padding-bottom: 3px;
}

.state-map {
  position: absolute;
  width: 180px;
  right: -60px;
  top: -30px;
}

.region-left {
  background-repeat: no-repeat;
  background-size: 80px;
  padding-left: 100px;
}

.region-right {
  padding-top: 30px;
}

.north-alabama {
  background-image: url('/images/areas/header-icon-north.svg');
}

.central-alabama {
  background-image: url('/images/areas/header-icon-central.svg');
}

.south-alabama {
  background-image: url('/images/areas/header-icon-south.svg');
}

.beaches-gulf-coast {
  background-image: url('/images/areas/header-icon-gulf-coast.svg');
}

.description-area {
  font-family: 'IdealSans-Book', 'Avenir', Helvetica, Arial, sans-serif;
  min-height: 400px;
}

.makers {
  background-image: url('/images/makers/alabama-makers.png');
}

.menu-item {
  padding: 10px;
}

.time-of-day-menu-item {
  font-weight: bold;
}

.trail-detail {
  background-image: url('/images/trails/trails-hd-icon.svg');
}

.description-area p {
  padding-right: 25px;
}

.img-fluid {
  width: 100%;
}

.discription-wrapper {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 550px;
  margin: 0 0 20px 0;
  padding: 0;
  white-space: pre-line;
}

.discription-wrapper::-webkit-scrollbar {
  width: 8px;
}

.discription-wrapper::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 3px rgba(78, 151, 178, 1);
  box-shadow: inset 0 0 3px rgba(78, 151, 178, 1);
}

.discription-wrapper::-webkit-scrollbar-thumb {
  background-color: #4e97b2;
  outline: 1px solid #91c0d2;
}

.is-passed {
  color: red;
}

.is-passed-text {
  display: block;
}

@media only screen and (max-width: 768px) {
  .fav-wrapper {
    left: 0px;
    top: 37px;
  }

  h1 {
    line-height: 3rem;
  }

  .north-alabama,
  .central-alabama,
  .south-alabama,
  .beaches-gulf-coast {
    background-image: none;
  }

  .region-icon:before {
    height: 50px;
    width: 50px;
  }

  .region-icon:before {
    content: '';
    background-repeat: no-repeat;
    background-size: 55px;
    height: 58px;
    left: 16px;
    position: absolute;
    top: 2px;
    width: 55px;
  }

  .region-left {
    padding-left: 0px;
    padding-top: 0px;
  }

  .region-right {
    position: inherit;
    border-left: none !important;
    padding-left: 0px;
    padding-right: 0px;
  }

  .state-map {
    position: absolute;
    width: 61px;
    right: 5px;
    top: 15px;
    display: none;
  }

  .container {
    padding-left: 0px;
    padding-right: 0px;
  }

  .cta-mobile {
    display: block;
    bottom: 0px;
    left: 0px;
    z-index: 999;
    background-color: #4e97b2;
    right: 0px;
    text-align: center;
  }

  a.m-phone {
    display: inline-block;
    padding: 15px 75px 15px 25px;
    color: #ffffff;
    float: right;
  }

  .button.no-carrot {
    padding: 15px 25px;
    float: left;
  }

  .phone-mobile {
    width: 15px;
    margin-right: 5px;
  }

  .cta-mobile a {
    color: #ffffff;
  }

  .button.no-carrot {
    display: inline-block !important;
    width: auto;
  }

  .trail-detail {
    background-position: 15px 0px;
  }

  .discription-wrapper {
    max-height: none;
  }
}

@media only screen and (max-width: 740px) {
  .north-alabama,
  .central-alabama,
  .south-alabama,
  .beaches-gulf-coast {
    background-position-x: 15px;
  }

  .mobile-img {
    display: block !important;
    margin-bottom: 20px;
  }

  .desktop-img {
    display: none;
  }

  .mt-5 {
    margin-top: 1rem !important;
  }

  .region-left {
    padding-left: 15px;
    padding-right: 15px;
  }

  .region-right {
    position: inherit;
    border-left: none !important;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
  }

  .border-left {
    padding-bottom: 0px;
  }

  .container {
    padding-left: 15px;
    padding-right: 15px;
  }
}

.breadcrumb {
  font-size: 12px;
  padding: 0 0 10px 0;

  @media only screen and (min-width: 768px) {
    font-size: 1.2rem;
  }
}

.ticket-button {
  background-color: #4e97b2;
  border: none;
  border-radius: 5px;
  color: white !important;
  display: inline-block;
  font-family: 'IdealSans-Medium';
  font-size: 1.1rem;
  font-weight: 500;
  margin-left: 50px;
  min-height: 50px;
  padding: 15px 35px 15px 25px;
  position: relative;
  -webkit-transition: background-color 500ms;
  transition: background-color 500ms;
  text-decoration: underline !important;
}

.ticket-button:hover {
  background-color: #357e99;
  color: #ffffff;
  cursor: pointer;
  -webkit-transition: background-color 500ms;
  transition: background-color 500ms;
}

.mobile-cta-wrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;

  & .ticket-button {
    margin: 30px auto 20px;
    text-align: center;
    width: 100%;
  }

  & .button.no-carrot {
    text-align: center;
    width: 100%;
  }

  @media screen and (min-width: 375px) and (max-width: 768px) {
    width: 70%;
    margin: auto;

    & .ticket-button {
      margin: 30px auto 20px;
    }
  }

  @media screen and (min-width: 769px) and (max-width: 820px) {
    width: 100%;
    margin: auto;
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;

    & .ticket-button {
      text-align: center;
      width: 200px;
    }

    & .button.no-carrot {
      width: 200px;
      margin-top: 9px;
    }
  }

  @media screen and (min-width: 821px) and (max-width: 1024px) {
    margin-right: 55px;

    & .ticket-button {
      margin: 30px auto 20px;
      text-align: center;
      width: 100%;
    }
  }
}
</style>
